import React, { useContext, useState } from 'react';
import Moment from 'moment';
import { useHistory } from 'react-router-dom';
import { Container, Typography, Grid, Button, CircularProgress, Box } from '@mui/material';
import { green } from '@mui/material/colors';
import FieldActivityContext from '../contexts/FieldActivityContext';
import StopsContext from '../contexts/StopsContext';
import UserContext from '../contexts/UserContext';
import FieldActivityFinder from '../utils/updateHelper';
import FieldActivityClosureStatus from '../utils/FieldActivityClosureStatus';
import FieldActivityRemarks from '../utils/FieldActivityRemarks';
import { BottomNav } from './BottomNav';


const ConfirmForemanInvestigateBody = (props) => {
    const history = useHistory();

    const { fieldActivityId } = useContext(FieldActivityContext);
    const { stops, setStops } = useContext(StopsContext);
    const { currentUser } = useContext(UserContext);

    const [loading, setLoading] = useState(false);

    let faClosureStatusCode = FieldActivityClosureStatus.FOREMAN_INVESTIGATE;
    let faRemarkValue = FieldActivityRemarks.FOREMAN_INVESTIGATE;

    const handleClickNo = () => {
        history.goBack();
    };

    const goBackToRouteScreen = () => {
        history.go(-2);
    };

    const handleClickYes = () => {
        const now = Moment().format('MM/DD/YYYY h:mm A');
        setLoading(true);
        //update fa in app
        const newStops = [...stops];
        let faForUpdate = FieldActivityFinder(newStops, fieldActivityId);
        faForUpdate.update.FieldActivityRemark = props.selectionType;
        faForUpdate.update.FieldActivityRemarkValue = faRemarkValue;
        faForUpdate.update.DynamicsClosureStatus = faClosureStatusCode;
        faForUpdate.update.ModifiedDateTime = now;
        faForUpdate.update.CompletedDateTime = now;

        faForUpdate.update.Status = 'PENDING';
        faForUpdate.update.CompletedBy = currentUser;
        //faForUpdate.update.Status = 'FOREMAN INVESTIGATE';
        faForUpdate.update.ForemanInvestigateFlag = true;
        //Saved, Synced, ModifiedLocally?
        //faForUpdate.update.Saved = true;

        let logMessage = `Mobile App user ${currentUser} selected ${props.selectionType} at ${now}.`;
        console.log("logMessage: ", logMessage);
        faForUpdate.update.NeedsToPostLog = true;
        faForUpdate.update.LogMessage = logMessage;

        //FI is a special case that calls a flow with branching logic and may or may not pass the SR #
        //We don't update CC&B for FI cases, just send the email via flow call
        faForUpdate.update.NeedsToUpdateDynamics = true;

        newStops[faForUpdate.index] = faForUpdate.update;
        setStops(newStops);

        setTimeout(function() {
            //setLoading(false);
            goBackToRouteScreen();
        }, 3000);

    };

    return (
        <React.Fragment>
            <Container maxWidth={false}>
                <Box sx={{ flexGrow: 1 }}>
                    <Grid
                        container
                        direction="column"
                        alignItems="center"
                        justifyContent="center"
                        style={{textAlign: 'center'}}
                        spacing={2}
                    >
                        <Typography variant="h3" component="h2" gutterBottom style={{ marginTop: 100}}>
                            You have selected {props.selectionType}.
                        </Typography>
                        <Typography variant="h4" gutterBottom>
                            Is this correct?
                        </Typography>
                    </Grid>
                    <Grid item xs={6} style={{textAlign: 'center'}}>
                        {loading && <CircularProgress size={50} sx={{ color: green[500], position: 'absolute', top: '50%', left: '50%', marginTop: "-12px", marginLeft: "-12px"}} />}
                    </Grid>
                </Box>
            </Container>
            <BottomNav>
                    <Button className={"secondary"}  component="a" onClick={handleClickNo}>NO</Button>
                    <Button className={"primary"} component="a" onClick={handleClickYes}>YES</Button>
                </BottomNav>
        </React.Fragment>
    );


};

export { ConfirmForemanInvestigateBody };